var caseInsensitiveFilter = function caseInsensitiveFilter(option, inputValue) {
  var optionLabel = option.content.toLowerCase();
  var optionValue = option.value.toLowerCase();
  var searchText = inputValue.toLowerCase();
  var searchLength = inputValue.length;
  return optionLabel.substr(0, searchLength) === searchText || optionValue.substr(0, searchLength) === searchText;
};

export default caseInsensitiveFilter;